import React from 'react';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { toLocalDate, toUTCDateWithNoon } from '../utils/dateUtils';

export default function DateField({ label = '', name, value, onChange, error, helperText }) {
    const handleChange = (e) => {
        const localDate = e.target.value;
        const utcDateTime = toUTCDateWithNoon(localDate);
        onChange({ target: { name, value: utcDateTime } });
    };

    return (
        <TextField
            variant="standard"
            fullWidth
            label={label}
            name={name}
            type="date"
            slotProps={{
                inputLabel: { shrink: true },
            }}
            value={toLocalDate(value)}
            onChange={handleChange}
            error={!!error}
            helperText={helperText}
        />
    );
}

DateField.propTypes = {
    label: PropTypes.string, // made optional
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};
